////////////////////////////////////////////////
//
// opener
//
////////////////////////////////////////////////
class YGQuickViewModalOpener extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("button");

    this.onButtonClickHandler = this.onButtonClick.bind(this);

    if (this.button) {
      this.button.addEventListener("click", this.onButtonClickHandler);
    } else {
      console.log("Button NOT found - checking shadow DOM");
    }
  }

  connectedCallback() {
    this.button = this.querySelector("button");

    if (this.button) {
      this.button.addEventListener("click", this.onButtonClickHandler);
    }
  }

  async onButtonClick(event) {
    let modal = document.querySelector(this.dataset.modal);

    // 第一次加载 modal
    if (!modal) {
      this.button.setAttribute("aria-disabled", true);
      this.button.classList.add("loading");

      this.button
        .querySelector(".loading-overlay__spinner")
        ?.classList.remove("hidden");

      const html = await fetch(
        `${Shopify.routes.root}?section_id=yg-quick-view-modal`
      ).then((r) => r.text());

      const modalEl = getDomHtmlFromText(
        html,
        "yg-quick-view-modal"
      );

      document.body.appendChild(modalEl);

      modal = modalEl;
    }
    modal?.show(this.button);
  }

  disconnectedCallback() {
    this.button?.removeEventListener(
      "click",
      this.onButtonClickHandler
    );
  }
}


if (!customElements.get("yg-quick-view-modal-opener")) {
  customElements.define(
    "yg-quick-view-modal-opener",
    YGQuickViewModalOpener
  );
}
////////////////////////////////////////////////
//
// modal
//
////////////////////////////////////////////////

class YGQuickViewModal extends HTMLElement {
  constructor() {
    super();

    this.modalContent = this.querySelector('[id^="YGQuickViewInfo-"]');

    this.closeBtn = this.querySelector("[data-modal-close]");

    this.onClose = this.hide.bind(this);
  }

  ////////////////////////////////////////
  // lifecycle
  ////////////////////////////////////////

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", this.onClose);
    }

    this.addEventListener("click", (e) => {
      if (e.target === this) {
        this.hide();
      }
    });

    document.addEventListener("keyup", (e) => {
      if (e.key === "Escape") {
        this.hide();
      }
    });
  }

  disconnectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.removeEventListener("click", this.onClose);
    }
  }

  ////////////////////////////////////////
  // open
  ////////////////////////////////////////

  show(opener) {
    this.opener = opener;

    this.setLoading(true);

    document.documentElement.classList.add("overflow-hidden");

    this.classList.add("is-opening");

    this.removeAttribute("hidden");

    ////////////////////////////////////////
    // 调用 yg 模板
    ////////////////////////////////////////

    let url = opener.dataset.productUrl.split("?")[0];

    url += "?view=yg-quick-view";

    fetch(url)
      .then((r) => r.text())

      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");


        this.productElement = doc.querySelector(".main-product-template-wrapper");
        console.log("productElement: ", this.productElement);

        if (!this.productElement) {
          console.warn("yg quickview template not found");

          return;
        }

        ////////////////////////////////////////

        this.preventDuplicatedIDs();

        this.setInnerHTML(
          this.modalContent,

          this.productElement.innerHTML,
        );
        this.reinitializeContent();

        ////////////////////////////////////////
        // 调用 section init 函数初始化脚本
        ////////////////////////////////////////
        if (window.YGQuickProductSection && typeof window.YGQuickProductSection.init === 'function') {
          window.YGQuickProductSection.init(this.modalContent);
        }

        ////////////////////////////////////////

        this.initShopifyFeatures();

        this.removeGalleryListSemantic();

        this.updateImageSizes();

        this.preventVariantURLSwitching();

        ////////////////////////////////////////

        requestAnimationFrame(() => {
          this.classList.add("open");

          this.classList.remove("is-opening");
        });
      })

      .catch(console.error)

      .finally(() => {
        this.setLoading(false);
      });
  }

  ////////////////////////////////////////
  // load product by handle
  ////////////////////////////////////////

  loadProductByHandle(handle) {
    this.setLoading(true);

    let url = `${Shopify.routes.root}products/${handle}?view=yg-quick-view`;

    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");

        this.productElement = doc.querySelector(".main-product-template-wrapper");

        if (!this.productElement) {
          console.warn("yg quickview template not found");
          return;
        }

        this.preventDuplicatedIDs();

        this.setInnerHTML(
          this.modalContent,
          this.productElement.innerHTML,
        );

        this.reinitializeContent();

        ////////////////////////////////////////
        // 调用 section init 函数初始化脚本
        ////////////////////////////////////////
        if (window.YGQuickProductSection && typeof window.YGQuickProductSection.init === 'function') {
          window.YGQuickProductSection.init(this.modalContent);
        }

        ////////////////////////////////////////

        this.initShopifyFeatures();

        this.removeGalleryListSemantic();

        this.updateImageSizes();

        this.preventVariantURLSwitching();
      })
      .catch(console.error)
      .finally(() => {
        this.setLoading(false);
      });
  }

  ////////////////////////////////////////
  // close
  ////////////////////////////////////////

  hide() {
    this.classList.remove("open");

    document.documentElement.classList.remove("overflow-hidden");

    setTimeout(() => {
      this.modalContent.innerHTML = "";

      this.setAttribute("hidden", "");
    }, 300);
  }

  ////////////////////////////////////////
  // loading
  ////////////////////////////////////////

  setLoading(state) {
    if (!this.opener) return;

    this.opener.toggleAttribute("aria-disabled", state);

    this.opener.classList.toggle("loading", state);

    const spinner = this.opener.querySelector(".loading-overlay__spinner");

    if (spinner) {
      spinner.classList.toggle("hidden", !state);
    }
  }

  reinitializeContent() {
    this.initSwipers();
    this.initCustomDropdowns();
    this.upgradeCustomElements();

    // 初始化 JudgeMe 评分星星图标
    if (window.Judgeme) {
      if (typeof window.Judgeme.boot === 'function') {
        window.Judgeme.boot();
      } else if (typeof window.Judgeme.init === 'function') {
        window.Judgeme.init();
      } else if (typeof window.Judgeme.CSSRewriter !== 'undefined') {
        window.Judgeme.CSSRewriter.rewrite();
      }
    }

    // 兜底：手动触发 CSS 重写类，强制显示星星
    const badge = this.modalContent.querySelector('.jdgm-preview-badge');
    if (badge) {
      badge.querySelectorAll('.jdgm-star').forEach(star => {
        star.classList.add('jdgm--rewriting');
        star.classList.remove('jdgm--rewriting');
      });
    }

    // 手动给 jdgm-star 嵌入 SVG 星星图标
    const stars = this.modalContent.querySelectorAll('.jdgm-star');
    if (stars.length) {
      const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
        <path d="M6.69489 0.234665C6.82502 -0.0782082 7.26824 -0.0782094 7.39837 0.234664L9.0733 4.26167C9.12816 4.39357 9.2522 4.48369 9.3946 4.49511L13.7421 4.84365C14.0799 4.87073 14.2168 5.29225 13.9595 5.5127L10.6471 8.35006C10.5387 8.443 10.4913 8.58882 10.5244 8.72777L11.5364 12.9702C11.615 13.2998 11.2564 13.5603 10.9673 13.3837L7.2452 11.1103C7.12329 11.0358 6.96997 11.0358 6.84806 11.1103L3.126 13.3837C2.83682 13.5603 2.47824 13.2998 2.55687 12.9702L3.56884 8.72777C3.60198 8.58882 3.5546 8.443 3.44611 8.35006L0.133782 5.5127C-0.123566 5.29225 0.0133956 4.87073 0.351169 4.84365L4.69866 4.49511C4.84106 4.48369 4.9651 4.39357 5.01996 4.26167L6.69489 0.234665Z" fill="#FF6A00"/>
      </svg>`;
      stars.forEach(star => {
        star.innerHTML = svgIcon;
      });
    }
  }

  ////////////////////////////////////////
  // Swiper
  ////////////////////////////////////////

  initSwipers() {
    // 缩略图 Swiper
    this.thumbs_swiper = new Swiper('.thumbs-swiper', {
      observer: true,
      observeParents: true,
      slidesPerView: 5,
      spaceBetween: 8,
      watchSlidesVisibility: true,
      watchOverflow: true,
      slideThumbClickable: true,
      navigation: {
        nextEl: '.thumbs-swiper .swiper-button-next',
        prevEl: '.thumbs-swiper .swiper-button-prev',
      },
    });

    // 主图 Swiper（带 thumbs 联动）
    this.gallery_swiper = new Swiper('.gallery-swiper', {
      observer: true,
      observeParents: true,
      slidesPerView: 1,
      effect: 'fade',
      speed: 500,
      thumbs: {
        swiper: this.thumbs_swiper,
      },
      navigation: {
        nextEl: '.gallery-swiper .swiper-button-next',
        prevEl: '.gallery-swiper .swiper-button-prev',
      },
    });
  }


  // 下拉列表
  initCustomDropdowns() {

    const dropdowns =
      this.modalContent.querySelectorAll(".custom-dropdown");
      if (!dropdowns.length) return;
      dropdowns.forEach((dropdown) => {
        if (dropdown.dataset.initialized) return;
        dropdown.dataset.initialized = "true";
    
        const trigger =
          dropdown.querySelector(".dropdown-trigger");
    
        const options =
          dropdown.querySelectorAll(".dropdown-option");
    
        const parentContainer =
          dropdown.closest(".product-form__input--dropdown");
    
        ////////////////////////////////////////
        // toggle
        ////////////////////////////////////////
    
        trigger?.addEventListener("click", (e) => {
    
          e.stopPropagation();
    
          const isOpen =
            dropdown.classList.contains("open");
    
          dropdowns.forEach((d) => {
    
            d.classList.remove("open");
    
            const p =
              d.closest(".product-form__input--dropdown");
    
            p?.classList.remove("is-active-dropdown");
    
          });
    
          if (!isOpen) {
    
            dropdown.classList.add("open");
    
            parentContainer?.classList.add(
              "is-active-dropdown"
            );
    
          }
    
        });
    
        ////////////////////////////////////////
        // option click
        ////////////////////////////////////////

        options.forEach((option) => {

          option.addEventListener("click", () => {

            const handle = option.getAttribute("data-handle");

            if (handle) {

              this.loadProductByHandle(handle);

            }

          });

        });
    
      });
  
    ////////////////////////////////////////
    // click outside
    ////////////////////////////////////////
  
    if (!this._dropdownDocHandler) {
  
      this._dropdownDocHandler = (e) => {
  
        dropdowns.forEach((dropdown) => {
  
          if (!dropdown.contains(e.target)) {
  
            dropdown.classList.remove("open");
  
            dropdown
              .closest(".product-form__input--dropdown")
              ?.classList.remove("is-active-dropdown");
  
          }
  
        });
  
      };
  
      document.addEventListener(
        "click",
        this._dropdownDocHandler
      );
  
    }
  
  }

  // 折扣
  upgradeCustomElements() {

    const elements =
      this.modalContent.querySelectorAll('yg-discount');
  
    elements.forEach(el => {
  
      customElements.upgrade(el);
  
    });
  
  }

  ////////////////////////////////////////
  // html inject
  ////////////////////////////////////////

  setInnerHTML(el, html) {
    el.innerHTML = html;

    el.querySelectorAll("script")

      .forEach((oldScript) => {
        const script = document.createElement("script");

        [...oldScript.attributes].forEach((attr) =>
          script.setAttribute(attr.name, attr.value),
        );

        script.textContent = oldScript.textContent;

        oldScript.replaceWith(script);
      });

    // 处理动态注入的 <style> 标签，确保样式生效
    el.querySelectorAll("style")

      .forEach((oldStyle) => {
        const style = document.createElement("style");

        [...oldStyle.attributes].forEach((attr) =>
          style.setAttribute(attr.name, attr.value),
        );

        style.textContent = oldStyle.textContent;

        oldStyle.replaceWith(style);
      });
  }

  ////////////////////////////////////////
  // shopify helpers
  ////////////////////////////////////////

  initShopifyFeatures() {
    window.Shopify?.PaymentButton?.init();

    window.ProductModel?.loadShopifyXR();
  }

  preventVariantURLSwitching() {
    this.modalContent

      .querySelectorAll("variant-radios,variant-selects")

      .forEach((el) => el.setAttribute("data-update-url", "false"));
  }

  preventDuplicatedIDs() {
    const sectionId = this.productElement.dataset.section;

    if (!sectionId) return;

    this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
      sectionId,

      `yg-${sectionId}`,
    );

    this.productElement

      .querySelectorAll("variant-selects,variant-radios")

      .forEach((el) => (el.dataset.originalSection = sectionId));
  }

  removeGalleryListSemantic() {
    const galleryList = this.modalContent.querySelector(
      '[id^="Slider-Gallery"]',
    );

    if (!galleryList) return;

    galleryList.setAttribute("role", "presentation");

    galleryList

      .querySelectorAll('[id^="Slide-"]')

      .forEach((li) => li.setAttribute("role", "presentation"));
  }

  updateImageSizes() {
    const product = this.modalContent.querySelector(".product");

    if (!product) return;

    const images = product.querySelectorAll(".product__media img");

    images.forEach((img) =>
      img.setAttribute(
        "sizes",

        "(min-width: 1000px) 715px, 100vw",
      ),
    );
  }
}
if (!customElements.get("yg-quick-view-modal")) {
  customElements.define("yg-quick-view-modal", YGQuickViewModal);
}
